import { render, staticRenderFns } from "./BusinessLicenseUpload.vue?vue&type=template&id=1a939c3a&scoped=true"
import script from "./BusinessLicenseUpload.vue?vue&type=script&lang=js"
export * from "./BusinessLicenseUpload.vue?vue&type=script&lang=js"
import style0 from "./BusinessLicenseUpload.vue?vue&type=style&index=0&id=1a939c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a939c3a",
  null
  
)

export default component.exports